import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { TextField, FormControl, MenuItem, Select, Checkbox, Button, Alert, Snackbar  } from '@mui/material'
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';

const ShopConfig = () => {
  return (
    <div>
      <EntrepreneurInformation />
      <Payment />
      <Delivery />
      {/* <Elseelse /> */}
    </div>
  )
}

const useStylesEntrepreneurInformation = makeStyles((theme) => ({
  row:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  firstSpanDiv:{
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2'
  },
  firstSpan:{
    fontSize:'14px'
  },
  ItemConfigBlock:{
    fontSize:'14px'
  },
  ItemConfigBlockH1:{
    padding:'40px 0 0 10px',
    fontWeight:'700',
    fontSize:'22px',

  },
  ItemConfigLi:{ 
    display:'flex',    
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  ItemConfigSpan:{
    width:'250px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      paddingBottom:'10px'
    },
  },
  textFieldShort:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  twoFlexLi:{
    display:'flex',
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  ItemConfigLiLeft:{
    width:'50%',
    display:'flex',
    alignItems:'center', 
    
    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
      paddingBottom:'10px'
    },
  },
  ItemConfigLiRight:{
    width:'50%',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1024)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
    },
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px'
  },
  btnButton:{
    margin:'0 40px'
  },

}))
const EntrepreneurInformation = () => {

  const theme = useTheme();
  const classes = useStylesEntrepreneurInformation(theme);

  //쇼핑몰설정1
  const [deAdminCompanyName, setdeAdminCompanyName ] = useState('');
  const [deAdminCompanySaupjaNo, setdeAdminCompanySaupjaNo] = useState('');
  const [deAdminCompanyOwner, setdeAdminCompanyOwner] = useState('');
  const [deAdminCompanyTel, setdeAdminCompanyTel] = useState('');
  const [deAdminCompanyFax, setdeAdminCompanyFax] = useState('');
  const [deAdminTongsinNo, setdeAdminTongsinNo] = useState('');
  const [deAdminBugaNo, setdeAdminBugaNo] = useState('');
  const [deAdmiCcompanyZip, setdeAdmiCcompanyZip] = useState('');
  const [deAdminCompanyAddr, setdeAdminCompanyAddr] = useState('');
  const [deAdminInfoName, setdeAdminInfoName] = useState('');
  const [deAdminInfoEmail, setdeAdminInfoEmail] = useState('');
  const [deSmsHp, setdeSmsHp] = useState('');

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const getData = async() => {
    try{
      const res = await axios.get('/api/adm/shopDefaultPart1/')
      const resData = res.data.result

      setdeAdminCompanyName(resData.de_admin_company_name)
      setdeAdminCompanySaupjaNo(resData.de_admin_company_saupja_no)
      setdeAdminCompanyOwner(resData.de_admin_company_owner)
      setdeAdminCompanyTel(resData.de_admin_company_tel)
      setdeAdminCompanyFax(resData.de_admin_company_fax)
      setdeAdminTongsinNo(resData.de_admin_tongsin_no)
      setdeAdminBugaNo(resData.de_admin_buga_no)
      setdeAdmiCcompanyZip(resData.de_admin_company_zip)
      setdeAdminCompanyAddr(resData.de_admin_company_addr)
      setdeAdminInfoName(resData.de_admin_info_name)
      setdeAdminInfoEmail(resData.de_admin_info_email)
      setdeSmsHp(resData.de_sms_hp)
    }catch (e) {
      console.log(e)
    }
  }
  useEffect(() => {
    getData()
  }, [])

  const editData = async() => {
    try {
      const res = await axios.post('/api/adm/shopDefaultEdit1/', {
        de_admin_company_name: deAdminCompanyName,
        de_admin_company_saupja_no: deAdminCompanySaupjaNo,
        de_admin_company_owner: deAdminCompanyOwner,
        de_admin_company_tel: deAdminCompanyTel,
        de_admin_company_fax: deAdminCompanyFax,
        de_admin_tongsin_no: deAdminTongsinNo,
        de_admin_buga_no: deAdminBugaNo,
        de_admin_company_zip: deAdmiCcompanyZip,
        de_admin_company_addr: deAdminCompanyAddr,
        de_admin_info_name: deAdminInfoName,
        de_admin_info_email: deAdminInfoEmail,
        de_sms_hp: deSmsHp
      })

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      setSuccSnack(true)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }


  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };


  return(
    <div className={classes.ItemConfigBlock}>
      <div className={classes.row}>
        <h1 className={classes.ItemConfigBlockH1}>사업자정보</h1>
        <ul className={classes.ItemConfigUl}>
          <li className={classes.twoFlexLi}>
            <div className={classes.ItemConfigLiLeft}>
              <span className={classes.ItemConfigSpan}>회사명</span>
              <TextField 
                value={deAdminCompanyName} 
                onChange={(event) => {setdeAdminCompanyName(event.target.value)}} 
                size='small' 
                sx={{"& .MuiInputBase-root": {height: 25}}}  
                className={classes.textFieldShort} 
                hiddenlabel="true"
                variant="outlined" 
              />
            </div>
            <div className={classes.ItemConfigLiRight}>
              <span className={classes.ItemConfigSpan} >사업자등록번호</span>
              <TextField 
                value={deAdminCompanySaupjaNo} 
                onChange={(event) => {setdeAdminCompanySaupjaNo(event.target.value)}} 
                size='small' 
                sx={{"& .MuiInputBase-root": {height: 25}}} 
                className={classes.textFieldShort} 
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
          </li>
          <li className={classes.ItemConfigLi}>
            <span className={classes.ItemConfigSpan} >대표자명</span>
            <TextField value={deAdminCompanyOwner} 
              onChange={(event) => {setdeAdminCompanyOwner(event.target.value)}} 
              size='small' 
              sx={{"& .MuiInputBase-root": {height: 25}}} 
              className={classes.textFieldShort} 
              hiddenlabel="true" 
              variant="outlined"
            />
          </li>
          <li className={classes.twoFlexLi}>
            <div className={classes.ItemConfigLiLeft}>
              <span className={classes.ItemConfigSpan}>대표전화번호</span>
              <TextField value={deAdminCompanyTel} 
                onChange={(event) => {setdeAdminCompanyTel(event.target.value)}} 
                size='small' sx={{"& .MuiInputBase-root": {height: 25}}}  
                className={classes.textFieldShort} 
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
            <div className={classes.ItemConfigLiRight}>
              <span className={classes.ItemConfigSpan} >팩스번호</span>
              <TextField 
                value={deAdminCompanyFax} 
                onChange={(event) => {setdeAdminCompanyFax(event.target.value)}} 
                size='small' 
                sx={{"& .MuiInputBase-root": {height: 25}}} 
                className={classes.textFieldShort} 
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
          </li>
          <li className={classes.ItemConfigLi}>
            <span className={classes.ItemConfigSpan} >휴대폰번호</span>
            <TextField 
              value={deSmsHp} 
              onChange={(event) => {setdeSmsHp(event.target.value)}} 
              size='small' 
              sx={{"& .MuiInputBase-root": {height: 25}}} 
              className={classes.textFieldShort} 
              hiddenlabel="true" 
              variant="outlined"
            />
          </li>
          <li className={classes.twoFlexLi}>
            <div className={classes.ItemConfigLiLeft}>
              <span className={classes.ItemConfigSpan}>통신판매업 신고번호</span>
              <TextField 
                value={deAdminTongsinNo} 
                onChange={(event) => {setdeAdminTongsinNo(event.target.value)}} 
                size='small' 
                sx={{"& .MuiInputBase-root": {height: 25}}}  
                className={classes.textFieldShort} 
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
            <div className={classes.ItemConfigLiRight}>
              <span className={classes.ItemConfigSpan} >부가통신 사업자번호</span>
              <TextField 
                value={deAdminBugaNo} 
                onChange={(event) => {setdeAdminBugaNo(event.target.value)}} 
                size='small' 
                sx={{"& .MuiInputBase-root": {height: 25}}} 
                className={classes.textFieldShort} 
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
          </li>
          <li className={classes.twoFlexLi}>
            <div className={classes.ItemConfigLiLeft}>
              <span className={classes.ItemConfigSpan}>사업장우편번호</span>
              <TextField 
                value={deAdmiCcompanyZip} 
                onChange={(event) => {setdeAdmiCcompanyZip(event.target.value)}} 
                size='small' 
                sx={{"& .MuiInputBase-root": {height: 25}}}  
                className={classes.textFieldShort} 
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
            <div className={classes.ItemConfigLiRight}>
              <span className={classes.ItemConfigSpan} >사업장주소</span>
              <TextField 
                value={deAdminCompanyAddr} 
                onChange={(event) => {setdeAdminCompanyAddr(event.target.value)}} 
                size='small' 
                sx={{"& .MuiInputBase-root": {height: 25}}} 
                className={classes.textFieldShort} 
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
          </li>
          <li className={classes.twoFlexLi}>
            <div className={classes.ItemConfigLiLeft}>
              <span className={classes.ItemConfigSpan}>정보관리책임자명</span>
              <TextField 
                value={deAdminInfoName} 
                onChange={(event) => {setdeAdminInfoName(event.target.value)}} 
                size='small' 
                sx={{"& .MuiInputBase-root": {height: 25}}}  
                className={classes.textFieldShort} 
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
            <div className={classes.ItemConfigLiRight}>
              <span className={classes.ItemConfigSpan} >정보책임자 e-mail</span>
              <TextField 
                value={deAdminInfoEmail} 
                onChange={(event) => {setdeAdminInfoEmail(event.target.value)}} 
                size='small' 
                sx={{"& .MuiInputBase-root": {height: 25}}} 
                className={classes.textFieldShort} 
                hiddenlabel="true" 
                variant="outlined" 
              />
            </div>
          </li>
        </ul>
        <div className={classes.btnDiv}>
          <div>
            <Button 
              variant="contained"
              onClick={() => {editData()}} 
            >
              확인
            </Button>
          </div>
        </div>
      </div>
      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
    </div>
  )
}


const useStylesPayment = makeStyles((theme) => ({
  row:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  firstSpanDiv:{
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2'
  },
  firstSpan:{
    fontSize:'14px'
  },
  ItemConfigBlock:{
    fontSize:'14px'
  },
  ItemConfigBlockH1:{
    padding:'40px 0 0 10px',
    fontWeight:'700',
    fontSize:'22px'
  },
  ItemConfigLi:{ 
    display:'flex',    
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  ItemConfigSpan:{
    width:'250px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      paddingBottom:'10px'
    },
  },
  twoFlexLi:{
    display:'flex',
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  ItemConfigLiLeft:{
    width:'50%',
    display:'flex',  
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
    },
  },
  ItemConfigLiRight:{
    width:'50%',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
    },
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px'
  },
  btnButton:{
    margin:'0 40px'
  },
  UlLi:{
    paddingBottom:'10px'
  },
  UlLiP:{
    display:'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start'
  },
  formControl:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  formControlSelect:{ 
    width:'100%',
    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  ItemConfigLiTextarea:{
    width:'440px',
    height:'100px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  textFieldShort:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  oneSpanTextFieldShort:{
    width:'300px',

    [theme.breakpoints.down(1025)]: {
      width:'50%'
    },
  },
}))

const Payment = () => {

  const theme = useTheme();
  const classes = useStylesPayment(theme);

  //쇼핑몰설정 5
  const [deBankUse, setdeBankUse ] = useState(0);
  const [deBankAccount, setdeBankAccount ] = useState('');
  
  const [deSettleMinPoint, setdeSettleMinPoint ] = useState(0);
  const [deSettleMaxPoint, setdeSettleMaxPoint ] = useState(0);
  const [deSettlePointUnit,setdeSettlePointUnit ] = useState(100);
  const [deCardPointUse, setdeCardPointUse ] = useState(0);
  const [dePointDays, setdePointDays ] = useState(0);

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const getData = async() => {
    try{
      const res = await axios.get('/api/adm/shopDefaultPart5/')
      const resData = res.data.result

      setdeBankUse(resData.de_bank_use)
      setdeBankAccount(resData.de_bank_account)
      
      setdeSettleMinPoint(resData.de_settle_min_point)
      setdeSettleMaxPoint(resData.de_settle_max_point)
      setdeSettlePointUnit(resData.de_settle_point_unit)
      setdeCardPointUse(resData.de_card_noint_use)
      setdePointDays(resData.de_point_days)
    }
    catch(e) {
      console.log(e)
    }
  }
  useEffect(() => {
    getData()
  }, [])

  const editData = async() => {
    try {
      const res = await axios.post('/api/adm/shopDefaultEdit5/', {
        de_bank_use: deBankUse,
        de_bank_account: deBankAccount,
        de_settle_min_point: deSettleMinPoint,
        de_settle_max_point: deSettleMaxPoint,
        de_settle_point_unit: deSettlePointUnit,
        de_card_point_use: deCardPointUse,
        de_point_days: dePointDays,
      })

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      setSuccSnack(true)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return(
    <div className={classes.ItemConfigBlock}>
      <div className={classes.row}>
        <h1 className={classes.ItemConfigBlockH1}>결제설정</h1>
        <ul className={classes.ItemConfigUl}>
          {/* <li className={classes.ItemConfigLi}>
            <span className={classes.ItemConfigSpan}>무통장입금사용</span>
            <ul>
              <li className={classes.UlLi}><span>주문시 무통장으로 입금을 가능하게 할것인지를 설정합니다.</span></li>
              <li className={classes.UlLi}><span>사용할 경우 은행계좌번호를 반드시 입력하여 주십시오.</span></li>
              <li>
              <FormControl sx={{"& .MuiInputBase-root": {height: 25}}} className={classes.formControl}>
                <Select 
                  value={deBankUse}
                  hiddenlabel="true"
                  onChange={(event) => setdeBankUse(event.target.value)}
                  className={classes.formControlSelect}
                  size='small'
                >
                  <MenuItem value={0}>사용안함</MenuItem>
                  <MenuItem value={1}>사용</MenuItem>
                </Select>
              </FormControl>
              </li>
            </ul>
          </li> */}
          <li className={classes.ItemConfigLi}>
            <span className={classes.ItemConfigSpan}>은행계좌번호</span>
            <textarea 
              value={deBankAccount} 
              onChange={(event) => {setdeBankAccount(event.target.value)}} 
              className={classes.ItemConfigLiTextarea}
            />           
          </li>
          <li className={classes.ItemConfigLi}>
            <div className={classes.ItemConfigLiLeft}>
              <span className={classes.ItemConfigSpan} >결제 최소포인트</span>
              <ul>
                <li className={classes.UlLi}>
                  <span>회원의 포인트가 설정값 이상일 경우만 주문시 결제에 사용할 수 있습니다.</span>
                </li>
                <li className={classes.UlLi}>
                  <span>포인트 사용을 하지 않는 경우에는 의미가 없습니다.</span>
                </li>
                <li>
                  <span className={classes.UlLiP}>
                    <TextField 
                      value={deSettleMinPoint} 
                      onChange={(event) => {setdeSettleMinPoint(parseInt(event.target.value))}} 
                      size='small' 
                      sx={{"& .MuiInputBase-root": {height: 25}}} 
                      className={classes.textFieldShort} 
                      hiddenlabel="true" 
                      variant="outlined" 
                      type='number'
                    />
                    <span className={classes.UlLiPSpan}>점</span>
                  </span>
                </li>
              </ul>
            </div>
          </li>
          <li className={classes.ItemConfigLi}>
            <div className={classes.ItemConfigLiLeft}>
              <span className={classes.ItemConfigSpan} >최대 결제포인트</span>
              <ul>
                <li className={classes.UlLi}><span>주문 결제시 최대로 사용할 수 있는 포인트를 설정합니다.</span></li>
                <li className={classes.UlLi}><span>포인트 사용을 하지 않는 경우에는 의미가 없습니다.</span></li>
                <li>
                  <span className={classes.UlLiP}>
                    <TextField 
                      value={deSettleMaxPoint} 
                      onChange={(event) => {setdeSettleMaxPoint(parseInt(event.target.value))}} 
                      size='small' sx={{"& .MuiInputBase-root": {height: 25}}} 
                      className={classes.textFieldShort} 
                      hiddenlabel="true"
                      variant="outlined" 
                      type='number'
                    />
                    <span className={classes.UlLiPSpan}>점</span>
                  </span>
                </li>
              </ul>
            </div>
          </li>
          <li className={classes.ItemConfigLi}>
            <span className={classes.ItemConfigSpan}>결제 포인트단위</span>
            <ul>
              <li className={classes.UlLi}><span>주문 결제시 사용되는 포인트의 절사 단위를 설정합니다.</span></li>
              <li>
              <FormControl sx={{"& .MuiInputBase-root": {height: 25}}} className={classes.formControl}>
                <Select 
                  value={deSettlePointUnit}
                  hiddenlabel="true"
                  onChange={(event) => {setdeSettlePointUnit(event.target.value)}}
                  className={classes.formControlSelect}
                  size='small'
                >
                  <MenuItem value={100}>100</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                </Select>
              </FormControl>
              </li>
            </ul>
          </li>
          {/* <li className={classes.ItemConfigLi}>
            <span className={classes.ItemConfigSpan}>포인트부여</span>
            <ul>
              <li className={classes.UlLi}><span>신용카드, 계좌이체, 휴대폰 결제시 포인트를 부여할지를 설정합니다. (기본값은 '아니오')</span></li>
              <li>
              <FormControl sx={{"& .MuiInputBase-root": {height: 25}}} className={classes.formControl}>
                <Select 
                  value={deCardPointUse}
                  hiddenlabel="true"
                  onChange={(event) => {setdeCardPointUse(event.target.value)}}
                  className={classes.formControlSelect}
                  size='small'
                >
                  <MenuItem value={0}>아니오</MenuItem>
                  <MenuItem value={1}>예</MenuItem>
                </Select>
              </FormControl>
              </li>
            </ul>
          </li>
          <li className={classes.ItemConfigLi}>      
            <span className={classes.ItemConfigSpan} >주문완료 포인트</span>
            <ul>
              <li className={classes.UlLi}><span>주문자가 회원일 경우에만 주문완료시 포인트를 지급합니다. 주문취소, 반품 등을 고려하여 포인트를 지급할 적당한 기간을 입력하십시오. (기본값은 7일)</span></li>
              <li className={classes.UlLi}><span>0일로 설정하는 경우에는 주문완료와 동시에 포인트를 지급합니다.</span></li>
              <li>
                <span className={classes.UlLiP}>
                  <span className={classes.UlLiPSpan}>주문 완료</span>
                  <TextField 
                    value={dePointDays} 
                    onChange={(event) => {setdePointDays(parseInt(event.target.value))}} 
                    size='small' sx={{"& .MuiInputBase-root": {height: 25}}} 
                    className={classes.oneSpanTextFieldShort} 
                    hiddenlabel="true" 
                    variant="outlined" 
                    type='number'
                  />
                  <span className={classes.UlLiPSpan}>일 이후에 포인트를 지급</span>
                </span>
              </li>
            </ul>
          </li> */}
        </ul>
        <div className={classes.btnDiv}>
          <div>
            <Button 
              variant="contained"
              onClick={() => {editData()}} 
            >
              확인
            </Button>
          </div>
        </div>
      </div>
      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
    </div>
  )
}

const useStylesDelivery = makeStyles((theme) => ({
  row:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  firstSpanDiv:{
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2'
  },
  firstSpan:{
    fontSize:'14px'
  },
  ItemConfigBlock:{
    fontSize:'14px'
  },
  ItemConfigBlockH1:{
    padding:'40px 0 0 10px',
    fontWeight:'700',
    fontSize:'22px'
  },
  ItemConfigLi:{ 
    display:'flex',    
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  ItemConfigSpan:{
    width:'250px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      paddingBottom:'10px'
    },
  },
  twoFlexLi:{
    display:'flex',
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  ItemConfigLiLeft:{
    width:'50%',
    display:'flex',  
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
    },
  },
  ItemConfigLiRight:{
    width:'50%',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
    },
  },
  textFieldShort:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'90%'
    },
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px'
  },
  btnButton:{
    margin:'0 40px'
  },
  UlLi:{
    paddingBottom:'10px'
  },
  formControl:{
    width:'440px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  formControlSelect:{ 
    width:'100%',
  },
  ItemConfigLiReactQuill:{
    display:'flex',    
    padding:'0px 0 40px 10px',
    borderBottom:'1px solid #ddd',
    height:'400px',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      
    },
  },
  ItemConfigSpanReactQuill:{
    width:'250px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      textAlign:'center',
      padding:'10px 0'
      
    },
  },
  reactQuill:{
    width:'800px',
    height:'300px',

    [theme.breakpoints.down(1025)]: {
      width:'100%',
      height:'270px'
      
    },
  },
}))
const Delivery = () => {

  const theme = useTheme();
  const classes = useStylesDelivery(theme);

  //쇼핑몰설정 6
  const [ deSendCostList, setdeSendCostList] = useState(0)
  const [ deHopeDateUse, setdeHopeDateUse] = useState(0)
  const [ deHopeDateAfter, setdeHopeDateAfter] = useState('')
  const [ deBaesongContent, setdeBaesongContent] = useState('')
  const [ deChangeContent, setdeChangeContent] = useState('')

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const getData = async() => {
    try{
      const res = await axios.get('/api/adm/shopDefaultPart6/')
      const resData = res.data.result

      setdeSendCostList(resData.de_send_cost_list)
      setdeHopeDateUse(resData.de_hope_date_use)
      setdeHopeDateAfter(resData.de_hope_date_after)
      setdeBaesongContent(resData.de_baesong_content)
      setdeChangeContent(resData.de_change_content)
    }
    catch(e) {
      console.log(e)
    }
  }
  useEffect(() => {
    getData()
  }, [])

  const editData = async() => {
    try {
      const res = await axios.post('/api/adm/shopDefaultEdit6/', {
        de_send_cost_list: deSendCostList,
        de_hope_date_use: deHopeDateUse,
        de_hope_date_after: deHopeDateAfter,
        de_baesong_content: deBaesongContent,
        de_change_content: deChangeContent,
      })

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      setSuccSnack(true)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }


  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };


  return(
    <div className={classes.ItemConfigBlock}>
      <div className={classes.row}>
        <h1 className={classes.ItemConfigBlockH1}>배송설정</h1>
        <ul className={classes.ItemConfigUl}>
          <li className={classes.ItemConfigLi}>
            <div className={classes.ItemConfigLiLeft}>
              <span className={classes.ItemConfigSpan} >배송비</span>
              <ul>
                <li>
                  <span className={classes.UlLiP}>
                    <TextField 
                      value={deSendCostList} 
                      onChange={(event) => {setdeSendCostList(parseInt(event.target.value))}} 
                      size='small' 
                      sx={{"& .MuiInputBase-root": {height: 25}}} 
                      className={classes.textFieldShort} 
                      hiddenlabel="true" 
                      variant="outlined" 
                      type='number'
                    />
                    <span className={classes.UlLiPSpan}>원</span>
                  </span>
                </li>
              </ul>
            </div>
          </li>
          {/* <li className={classes.ItemConfigLi}>
            <span className={classes.ItemConfigSpan}>희망배송일사용</span>
            <ul>
              <li className={classes.UlLi}><span>'예'로 설정한 경우 주문서에서 희망배송일을 입력 받습니다.</span></li>
              <li>
              <FormControl sx={{"& .MuiInputBase-root": {height: 25}}} className={classes.formControl}>
                <Select 
                  value={deHopeDateUse}
                  hiddenlabel="true"
                  onChange={(event) => {setdeHopeDateUse(event.target.value)}}
                  className={classes.formControlSelect}
                  size='small'
                >
                  <MenuItem value={0}>사용안함</MenuItem>
                  <MenuItem value={1}>사용</MenuItem>
                </Select>
              </FormControl>
              </li>
            </ul>
          </li> */}
          <li className={classes.ItemConfigLi}>            
            <span className={classes.ItemConfigSpan}>희망배송일지정</span>
            <ul>
              <li className={classes.UlLi}><span>오늘을 포함하여 설정한 날 이후부터 일주일 동안을 달력 형식으로 노출하여 선택할수 있도록 합니다.</span></li>
              <li>
                <span className={classes.UlLiP}>
                  <TextField 
                    value={deHopeDateAfter} 
                    onChange={(event) => {setdeHopeDateAfter(parseInt(event.target.value))}} 
                    size='small' 
                    sx={{"& .MuiInputBase-root": {height: 25}}} 
                    className={classes.textFieldShort} 
                    hiddenlabel="true" 
                    variant="outlined" 
                    type='number'
                  />
                  <span className={classes.UlLiPSpan}>일</span>
                </span>
              </li>
            </ul>
          </li>
          {/* <li className={classes.ItemConfigLiReactQuill}>            
            <span className={classes.ItemConfigSpanReactQuill}>배송정보</span>
            <ul>
              <li>
                <span className={classes.UlLiP}>
                  <ReactQuill 
                    theme="snow" 
                    value={deBaesongContent} 
                    onChange={(content, delta, source, editor) => {setdeBaesongContent(editor.getHTML())}}
                    className={classes.reactQuill} 
                  />
                </span>
              </li>
            </ul>
          </li>
          <li className={classes.ItemConfigLiReactQuill}>            
            <span className={classes.ItemConfigSpanReactQuill}>교환/반품</span>
            <ul>
              <li>
                <span className={classes.UlLiP}>
                  <ReactQuill 
                    theme="snow" 
                    value={deChangeContent} 
                    onChange={(content, delta, source, editor) => {setdeChangeContent(editor.getHTML())}}
                    className={classes.reactQuill} 
                  />
                </span>
              </li>
            </ul>
          </li> */}
        </ul>
        <div 
          className={classes.btnDiv}
          style={{ padding:'0 0 20px 0'}}
        >
          <div>
            <Button 
              variant="contained"
              onClick={() => {editData()}} 
            >
              확인
            </Button>
          </div>
        </div>
      </div>
      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
    </div>
  )
}

const useStylesElse = makeStyles((theme) => ({
  row:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  firstSpanDiv:{
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2'
  },
  firstSpan:{
    fontSize:'14px'
  },
  ItemConfigBlock:{
    fontSize:'14px'
  },
  ItemConfigBlockH1:{
    padding:'40px 0 0 10px',
    fontWeight:'700',
    fontSize:'22px'
  },
  ItemConfigLi:{ 
    display:'flex',    
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  ItemConfigSpan:{
    width:'250px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      paddingBottom:'10px'
    },
  },
  ItemConfigUlLiSpan:{
    paddingBottom:'10px'
  },
  twoFlexLi:{
    display:'flex',
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'stretch',
    },
  },
  ItemConfigLiLeft:{
    width:'50%',
    display:'flex',  
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
    },
  },
  ItemConfigLiRight:{
    width:'50%',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      alignItems:'stretch',
    },    
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px'
  },
  btnButton:{
    margin:'0 40px'
  },
  elseelseUl:{
    display:'flex',
    alignItems: 'center',
    flexWrap:'wrap',
    paddingTop:'10px'
  },
  formControl:{
    width:'440px',
    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  textFieldShort:{
    width:'440px',
    [theme.breakpoints.down(1025)]: {
      width:'90%'
    },
  },
}))
const Elseelse = () => {

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const theme = useTheme();
  const classes = useStylesElse(theme);

  const [deItemUseWrite, setdeItemUseWrite ] = useState(0);
  const [deItemUseUse, setdeItemUseUse ] = useState(0);
  const [deLevelSell, setdeLevelSell ] = useState(0);
  const [deCodeDupUse, sedeCodeDupUset ] = useState(0)
  const [deCartKeepTerm, setdeCartKeepTerm ] = useState(0);

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const getData = async() => {
    try{
      const res = await axios.get('/api/adm/shopDefaultPart7/')
      const resData = res.data.result

      setdeItemUseWrite(resData.de_item_use_write)
      setdeItemUseUse(resData.de_item_use_use)
      setdeLevelSell(resData.de_level_sell)
      sedeCodeDupUset(resData.de_code_dup_use)
      setdeCartKeepTerm(resData.de_cart_keep_term)
    }
    catch(e) {
      console.log(e)
    }
  }
  useEffect(() => {
    getData()
  }, [])

  const editData = async() => {
    try {
      const res = await axios.post('/api/adm/shopDefaultEdit6/', {
        de_item_use_write: deItemUseWrite,
        de_item_use_use: deItemUseUse,
        de_level_sell: deLevelSell,
        de_code_dup_use: deCodeDupUse,
        de_cart_keep_term: deCartKeepTerm,
      })

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }

      setSuccSnack(true)
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };


  return(
    <div className={classes.ItemConfigBlock}>
      <div className={classes.row}>
        <h1 className={classes.ItemConfigBlockH1}>기타 설정</h1>
        <ul className={classes.ItemConfigUl}>
          
          <li className={classes.ItemConfigLi}>
            <span className={classes.ItemConfigSpan}>사용후기 작성</span>
            <ul>
              <li className={classes.ItemConfigUlLiSpan}><span>주문상태에 따른 사용후기 작성여부를 설정합니다.</span></li>
              <li>
              <FormControl sx={{"& .MuiInputBase-root": {height: 25}}} className={classes.formControl}>
                <Select 
                  value={deItemUseWrite}
                  hiddenlabel="true"
                  onChange={(event) => {setdeItemUseWrite(event.target.value)}}
                  className={classes.formControlSelect}
                  size='small'
                >
                  <MenuItem value={0}>주문상태와 무관하게 작성가능 </MenuItem>
                  <MenuItem value={1}>주문상태가 완료인 경우에만 작성가능</MenuItem>
                </Select>
              </FormControl>
              </li>
            </ul>
          </li>
          <li className={classes.ItemConfigLi}>
            <span className={classes.ItemConfigSpan}>사용후기</span>
            <ul>
              <li className={classes.ItemConfigUlLiSpan}><span>사용후기가 올라오면, 즉시 출력 혹은 관리자 승인 후 출력 여부를 설정합니다.</span></li>
              <li>
              <FormControl sx={{"& .MuiInputBase-root": {height: 25}}} className={classes.formControl}>
                <Select 
                  value={deItemUseUse}
                  hiddenlabel="true"
                  onChange={(event) => {setdeItemUseUse(event.target.value)}}
                  className={classes.formControlSelect}
                  size='small'
                >
                  <MenuItem value={0}>즉시 출력 </MenuItem>
                  <MenuItem value={1}>관리자가 승인 후 출력</MenuItem>
                </Select>
              </FormControl>
              </li>
            </ul>
          </li>
          <li className={classes.ItemConfigLi}>
            <span className={classes.ItemConfigSpan}>상품구입 권한</span>
            <ul>
              <li className={classes.ItemConfigUlLiSpan}><span>권한을 1로 설정하면 누구나 구입할 수 있습니다. 특정회원만 구입할 수 있도록 하려면 해당 권한으로 설정하십시오.</span></li>
              <li>
              <FormControl sx={{"& .MuiInputBase-root": {height: 25}}} className={classes.formControl}>
                <Select 
                  value={deLevelSell}
                  hiddenlabel="true"
                  onChange={(event) => {setdeLevelSell(event.target.value)}}
                  className={classes.formControlSelect}
                  size='small'
                >
                  <MenuItem value={0}>0 </MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2 </MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4 </MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={6}>6 </MenuItem>
                  <MenuItem value={7}>7</MenuItem>
                  <MenuItem value={8}>8 </MenuItem>
                  <MenuItem value={9}>9</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                </Select>
              </FormControl>
              </li>
            </ul>
          </li>
          <li className={classes.ItemConfigLi}>
            <span className={classes.ItemConfigSpan} >코드 중복검사</span>
            <ul>
              <li><span>분류, 상품 등을 추가할 때 자동으로 코드 중복검사를 하려면 체크하십시오.</span></li>
              <li>
                <span>
                  <Checkbox 
                    value={deCodeDupUse === 0 ? false : true} 
                    onChange={() => {
                      deCodeDupUse === 0 ?
                      sedeCodeDupUset(1):
                      sedeCodeDupUset(0)
                    }}  
                    {...label}
                  />
                  사용
                </span>
              </li>
            </ul>
          </li>
          <li className={classes.ItemConfigLi}>
            <span className={classes.ItemConfigSpan} >장바구니 보관기간</span>
            <ul>
              <li className={classes.ItemConfigUlLiSpan}>
                <span >장바구니 상품의 보관 기간을 설정하십시오.</span>
              </li>
              <li>
                <span className={classes.UlLiP}>
                  <TextField 
                    value={deCartKeepTerm} 
                    onChange={(event) => setdeCartKeepTerm(parseInt(event.target.value))} 
                    size='small' sx={{"& .MuiInputBase-root": {height: 25}}} 
                    className={classes.textFieldShort} 
                    hiddenlabel="true" 
                    variant="outlined" 
                    type='number'
                  />
                  <span>일</span>
                </span>
              </li>
            </ul>
          </li>
        </ul>
        <div 
          className={classes.btnDiv}
        >
          <div>
            <Button 
              variant="contained"
              onClick={() => {editData()}} 
            >
              확인
            </Button>
          </div>
        </div>
      </div>
      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
    </div>
  )
}


export default ShopConfig

